import AppConstants from "@/appConstants";
import jwtDecode from "jwt-decode";

class LocalStorageHelper {

  saveData(key, value) {
    window.localStorage.setItem(key, value);
  }

  clear() {
    window.localStorage.clear();
  }

  removeItem(key) {
    window.localStorage.removeItem(key);
  }

  updateToken(token) {
    const currentUser = this.getCurrentUser();
    currentUser.token = token;
    this.setCurrentUser(currentUser);
  }

  setDraftNews(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_DRAFT_NEWS, JSON.stringify(data));
  }

  getDraftNews() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_DRAFT_NEWS)) || [];
  }

  // ===============================================
  // ===============================================

  updateAcceptorToken(data) {
    const currentUser = this.getCurrentUser();
    currentUser.acptoken = data.token;
    currentUser.acpurl = data.url;
    this.setCurrentUser(currentUser);
  }

  updateWDMAInfo(data) {
    const currentUser = this.getCurrentUser();
    currentUser.sessionId = data.sessionId;
    currentUser.wdmasid = data.wdmasid;
    this.setCurrentUser(currentUser);
  }

  updateLocale(locale) {
    this.saveData(AppConstants.LOCAL_STORAGE_LOCALE, locale);
  }

  updateReportViewStyle(viewStyle) {
    this.saveData(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE, viewStyle);
  }

  setSidebarMainMenu(reduce) {
    this.saveData(AppConstants.LOCAL_STORAGE_MAIN_MENU_SIDEBAR_REDUCE, reduce);
  }

  setSidebarInformative(reduce) {
    this.saveData(AppConstants.LOCAL_STORAGE_INFORMATIVE_SIDEBAR_REDUCE, reduce);
  }

  setCurrentUser(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_CURRENT_USER, JSON.stringify(data));
  }

  setCurrentBrowserSession(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_SESSION_BROWSER, data);
  }

  getCurrentBrowserSession() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_SESSION_BROWSER);
  }

  getUserHasLoggedIn() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_HAS_LOGGED_IN);
  }

  getCurrentUser() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER)) || {};
  }

  getReportViewStyle() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_REPORT_VIEW_STYLE));
  }

  getTheme() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_THEME);
  }

  getLocale() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_LOCALE) || 'PtBr';
  }

  getUserId() {
    return jwtDecode(this.getCurrentUser().token).id;
  }

  // getCountryCode() {
  //   // Default is ptBr
  //   const defaultCountry = 1;
  //   try {
  //     const curUser = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
  //     return jwt_decode(curUser.token).country;
  //   } catch (e) {
  //     return defaultCountry;
  //   }
  // }

  getWdmaRoute() {
    // Default is ptBr
    const defaultCountry = 1;
    try {
      const curUser = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
      return jwtDecode(curUser.token).wdma_route;
    } catch (e) {
      return defaultCountry;
    }
  }

  getSidebarMainMenuReduce() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_MAIN_MENU_SIDEBAR_REDUCE) == "true";
  }

  getS4Login() {
    const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
    return user.s4Login;
  }

  getSidebarInformativeReduce() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_INFORMATIVE_SIDEBAR_REDUCE) == "true";
  }

  getMetadata() {
    try {
      const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));
      if (user.metadata && user.metadata.data) {
        return user.metadata.data;
      }
      return null;
    } catch (e) {
      return null;
    }
  }

  updateMetadata(metadata) {
    const currentUser = this.getCurrentUser();
    currentUser.metadata = metadata;
    this.setCurrentUser(currentUser);
  }

  getUserLayoutPrefs() {
    // Default prefs
    let prefs = {
      theme: "light",
      viewstyle: AppConstants.REPORT_VIEW_STYLE.CARDVIEW,
      favoriteContent: [],
      skipTour: false
    };

    try {
      const user = JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_USER));

      if (user.theme) {
        prefs.theme = user.theme;
      }

      if (user.viewstyle) {
        if (user.viewstyle === "0") {
          prefs.viewstyle = AppConstants.REPORT_VIEW_STYLE.LISTVIEW;
        } else {
          prefs.viewstyle = AppConstants.REPORT_VIEW_STYLE.CARDVIEW;
        }
      }

      if (user.favoriteContent) {
        prefs.favoriteContent = user.favoriteContent;
      }

      prefs.skipTour = user.skipTour || false;

      return prefs;
    } catch (e) {
      return prefs;
    }
  }

  getFavoriteMenuContent() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_FAVORITE_CONTENT)) || [];
  }

  updateFavoriteMenuContent(contentList) {
    const currentUser = this.getCurrentUser();
    currentUser.favoriteContent = contentList;
    this.setCurrentUser(currentUser);
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_FAVORITE_CONTENT, JSON.stringify(contentList));
  }

  checkExisteSessioninBrowser() {
    if (this.getCurrentBrowserSession() == 'true') {
      // alert('exist session in this browser');
      if (this.getUserHasLoggedIn() === 'true') {
        this.updateLogoutOldSession(true);
      }
    } else {
      this.updateLogoutOldSession(false);
    }

    this.setCurrentBrowserSession(true);
  }

  getLogoutOldSession() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_EVENT_CLOSE_SESSION);
  }
  updateLogoutOldSession(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_EVENT_CLOSE_SESSION, data);
  }

  getQuotesPageDetach() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_EVENT_QUOTES_PAGE_DETACH) || false;
  }
  updateQuotesPageDetach(data) {
    this.saveData(AppConstants.LOCAL_STORAGE_EVENT_QUOTES_PAGE_DETACH, data);
  }

  getUserSkipTour() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_USER_SKIP_TOUR) || false;
  }
  updateUserSkipTour(data) {
    const currentUser = this.getCurrentUser();
    currentUser.skipTour = data;
    this.setCurrentUser(currentUser);
    this.saveData(AppConstants.LOCAL_STORAGE_USER_SKIP_TOUR, data);
  }

  getFilterReport() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_FILTER_REPORT)) || [];
  }

  updateFilterReport(filter) {
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_FILTER_REPORT, JSON.stringify(filter));
  }
  
  updateVisitorId(visitorId) {
    window.localStorage.setItem(AppConstants.LOCAL_STORAGE_VISITOR, visitorId);
  }

  getVisitorId() {
    return window.localStorage.getItem(AppConstants.LOCAL_STORAGE_VISITOR) || '';
  }
  getCurrentOrigin() {
    return JSON.parse(window.localStorage.getItem(AppConstants.LOCAL_STORAGE_CURRENT_ORIGIN)) || null;
  }
}

export default new LocalStorageHelper();
